/* eslint-disable import/no-duplicates */
import { format, addHours, isToday, isTomorrow } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatDateToHHMM = (date: string | number): string => {
  return format(new Date(date || ""), "HH:mm");
};

export const formatDateToDDMMYYYY = (date: string | number): string => {
  return format(new Date(date || ""), "dd/MM/yyyy");
};

export const addHoursToDate = (
  date: string | number,
  hours: number,
): string => {
  return format(addHours(new Date(date), hours), "HH:mm");
};

export const getSchedulingDayLabel = (date: Date): string => {
  if (isToday(date)) return "hoje";
  if (isTomorrow(date)) return "amanhã";
  return format(date, "d 'de' MMMM", { locale: ptBR });
};

export const formatTimeLocal = (date: Date): string => {
  const h = date.getHours().toString().padStart(2, "0");
  const m = date.getMinutes().toString().padStart(2, "0");
  return `${h}:${m}`;
};
